import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { PAIN_POINTS } from '../utils/constants';
export function ProblemSection() {
  return <section className="bg-white py-16 px-4" data-id="element-229">
      <div className="max-w-7xl mx-auto" data-id="element-230">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-231">
          Ti riconosci in queste situazioni?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-232">
          {PAIN_POINTS.map((point, index) => <div key={index} className="bg-red-50 border border-red-100 rounded-lg p-6 flex gap-4" data-id="element-233">
              <XCircleIcon className="w-8 h-8 text-red-600 flex-shrink-0 mt-1" data-id="element-234" />
              <p className="text-lg text-gray-800" data-id="element-235">{point}</p>
            </div>)}
        </div>
      </div>
    </section>;
}